import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'billing',
    loadChildren: () => import('./features/billing/billing.routes').then((r) => r.BILLING_ROUTES),
  },
  {
    path: 'documentupload',
    loadChildren: () =>
      import('./features/document-upload/documentupload.routes').then(
        (r) => r.DOCUMENT_UPLOAD_ROUTES
      ),
  },
  {
    path: 'snl',
    loadChildren: () => import('./features/SNL/snl.routes').then((r) => r.SNL_ROUTES),
  },
  { path: '', redirectTo: 'billing', pathMatch: 'full' },
  { path: '**', redirectTo: 'billing' },
];
